import Loading from "./Loading";
import Modal from "./Modal";

function DeleteModal({ title, open, setOpen, isDeleting, onDelete }) {
  return (
    <div className="text-gray-700">
      <Modal title="" open={open} setOpen={setOpen}>
        <div className="flex flex-col justify-center items-center pt-2">
          <div className="text-lg  pb-4 border-b-2 border-gray-200 px-4">
            {title || "Are you sure, you want to delete this?"}
          </div>

          <div className="flex items-center space-x-4  my-4">
            <button
              className={`flex justify-center items-center space-x-2 bg-red-600 px-4 py-2 rounded-md text-white hover:bg-red-700 w-40 ${
                isDeleting ? "opacity-70 cursor-not-allowed" : ""
              }`}
              disabled={isDeleting}
              onClick={onDelete}
            >
              {isDeleting ? <Loading /> : null}
              Yes, Delete
            </button>
            <button
              className="border border-purple-600 px-4 py-2 text-white rounded-md common_bg nav_link-100 w-40"
              onClick={() => setOpen(false)}
            >
              No
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default DeleteModal;
